export default __webpack_public_path__ + "static/large-cabin-bathroom-5cc770bdf999200dd3dd83e58e0ddc40.jpg";